import { CheckoutEventSuccess } from '../../models/checkout/checkout-event-success.interface';

export const mockCheckoutEventSuccess: CheckoutEventSuccess = {
  eventDescription: 'Checkout was successful',
  transactionId: '123456',
  status: 'success',
  contracts: [
    {
      contractId: 'contract-id-1',
      offerReference: 'offer-ref-1',
      itemId: 'gen:item-id-1',
    },
  ],
  ...new CustomEvent('checkout-event-success', {
    detail: {
      eventDescription: 'Checkout was successful',
      transactionId: '123456',
      status: 'success',
      contracts: [
        {
          contractId: 'contract-id-1',
          offerReference: 'offer-ref-1',
          itemId: 'gen:item-id-1',
        },
        {
          contractId: 'contract-id-2',
          offerReference: 'offer-ref-2',
          itemId: 'gen:item-id-2',
        },
      ],
    },
  }),
};
